import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import GenericButton from '../common/GenericButton';

class TimeSpentLegends extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renamedLabel: '',
      showRename: false,
      showCombineWith: false,
    };
  }

  getStyles = () => ({
    minWidth: '110px',
    minHeight: '100px',
    height: 'auto',
    width: 'auto',
    border: '1px solid RGB(71, 100, 138)',
    position: 'absolute',
    left: `calc(${this.props.offsetX}px - 0% - 0rem - 10px)`,
    top: `calc(${this.props.offsetY}px + 27% - 0rem - 0px)`,
    display: this.props.visibility ? 'block' : 'none',
    backgroundColor: '#fff',
  });

  renderLabels = () =>
    this.props.labels
      .filter(label => label.value !== this.props.title)
      .map(label => (
        <p
          key={uuid()}
          onClick={() => {
            this.props.combineWith(label.value);
            this.props.toggleLegend();
          }}
        >
          {label.value}
        </p>
      ));

  renderRename = () => (
    <div className="rename-dropdown">
      <input
        type="text"
        onChange={e => this.setState({ renamedLabel: e.target.value })}
      />
      <GenericButton
        name="Apply Rename"
        btnStyle="button btn-rename"
        onBtnClick={() => {
          this.props.renameLegend(this.state.renamedLabel);
          this.props.toggleLegend();
        }}
      />
      <br />
    </div>
  );

  render() {
    return (
      <div>
        <div
          className="quick-reports-dropdown general-stats-table"
          style={this.getStyles()}
        >
          <p>{this.props.title}</p>
          <div>
            <GenericButton
              name="Remove"
              btnStyle="button"
              onBtnClick={() => {
                this.props.removeLegend();
                this.props.toggleLegend();
              }}
            />
            <br />
            <GenericButton
              name={`${
                this.state.showCombineWith
                  ? String.fromCharCode(9660)
                  : String.fromCharCode(9654)
              } Combine With`}
              btnStyle={`button ${this.state.showCombineWith ? 'active' : ''}`}
              onBtnClick={() => {
                this.setState({ showCombineWith: !this.state.showCombineWith });
              }}
            />
            <br />
            <div className="combine-with-list">
              {this.state.showCombineWith ? this.renderLabels() : null}
            </div>
            <GenericButton
              name={`${
                this.state.showRename
                  ? String.fromCharCode(9660)
                  : String.fromCharCode(9654)
              } Rename`}
              btnStyle={`button ${this.state.showRename ? 'active' : ''}`}
              onBtnClick={() => {
                this.setState({ showRename: !this.state.showRename });
              }}
            />
            <br />
            {this.state.showRename ? this.renderRename() : null}
            <GenericButton
              name=""
              btnStyle="btn-close"
              onBtnClick={() => this.props.toggleLegend()}
            />
          </div>
        </div>
      </div>
    );
  }
}

TimeSpentLegends.propTypes = {
  visibility: PropTypes.bool,
  event: PropTypes.shape({}),
};

export default TimeSpentLegends;
